import styled from "styled-components"

export const OtherBenefitsContainer = styled.div`
  padding: 80px 0;
  background-image: url(${props => props.img});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: #def4ff;

  @media (max-width: 768px) {
    padding: 40px 0;
  }

  h1 {
    color: ${props => props.theme.colors.darkBlue};
    margin-bottom: 40px;
  }

  h5 {
    color: ${props => props.theme.colors.darkBlue};
    margin-bottom: 12px;
  }

  .compound-image {
    img {
      width: 100%;
    }
    @media (max-width: 575px) {
      margin-bottom: 30px;
    }
  }

  .back-btn {
    margin-top: 48px;
    @media (max-width: 575px) {
      margin: 60px 0;
      a {
        display: block;
        width: 100%;
        text-align: center;
      }
    }
    a {
      background-color: ${props => props.theme.colors.brightBlue};
      color: ${props => props.theme.colors.white};
      padding: 12px;
      text-decoration: none;
      border-radius: 8px;
      transition: 0.3s ease;
      font-weight: 600;
      border: 2px solid ${props => props.theme.colors.brightBlue};
      &:hover {
        background-color: transparent;
        color: ${props => props.theme.colors.brightBlue};
      }
    }
  }
`

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`

export const TextBox = styled.div`
  background-color: rgba(255, 255, 255, 0.7);
  padding: 40px;
  margin-bottom: 30px;

  h3 {
    font-size: 24px;
    font-weight: 600;
    color: ${props => props.theme.colors.darkBlue};
    span {
      font-size: 24px;
      font-weight: 600;
      color: ${props => props.theme.colors.darkBlue};
    }
  }

  p {
    margin-bottom: 16px;
    color: ${props => props.theme.colors.darkBlue};
  }

  button {
    border: none;
    background: transparent;
    margin-top: 30px;
    display: block;
    margin-top: 12px;
    font-weight: 400;
    color: ${props => props.theme.colors.darkBlue} !important;
    &:hover {
      cursor: pointer;
    }
  }

  button::focus {
    outline: 2px solid red;
  }

  ul {
    columns: 3;
    -webkit-columns: 3;
    -moz-columns: 3;
    @media (max-width: 575px) {
      columns: 2;
      -webkit-columns: 2;
      -moz-columns: 2;
    }
    li {
      list-style: disc;
      margin: 8px 0px;
      color: ${props => props.theme.colors.darkBlue};
    }
    li:first-child {
      margin-top: 0;
    }
  }
`
